export default "__VITE_ASSET__24991a63__"